var map = {
	"./arrow-left.svg": 7485,
	"./camera-outline.svg": 73959,
	"./camera.svg": 71073,
	"./check-circle-white.svg": 42417,
	"./icons/calendar.svg": 90874,
	"./icons/rows.svg": 72058,
	"./icons/star.svg": 3740,
	"./logo-small.svg": 36934,
	"./logo-white-small.svg": 98963,
	"./logo-white.svg": 48789,
	"./logo.svg": 69574,
	"./map-pin-employee-other.svg": 56681,
	"./map-pin-employee.svg": 13195,
	"./map-pin-location.svg": 17586,
	"./powered-by-wagestream-white.svg": 15916,
	"./raise-logo-without-icon.svg": 4341,
	"./raise-text-logo.svg": 68376,
	"./shirt.svg": 31797,
	"./shoes.svg": 24423,
	"./speedometer.svg": 70260,
	"./star.svg": 36380,
	"./themes/mhritrent/logo-small.svg": 2203,
	"./themes/mhritrent/logo-white-small.svg": 20995,
	"./themes/mhritrent/logo-white.svg": 91819,
	"./themes/mhritrent/logo.svg": 61265,
	"./themes/mhrpeoplefirst/logo-small.svg": 64939,
	"./themes/mhrpeoplefirst/logo-white-small.svg": 40347,
	"./themes/mhrpeoplefirst/logo-white.svg": 13578,
	"./themes/mhrpeoplefirst/logo.svg": 24703,
	"./themes/wagestreamus/logo-small.svg": 36184,
	"./themes/wagestreamus/logo-white-small.svg": 9889,
	"./themes/wagestreamus/logo-white.svg": 14845,
	"./themes/wagestreamus/logo.svg": 47305,
	"./themes/zellis/logo-small.svg": 13061,
	"./themes/zellis/logo-white-small.svg": 5391,
	"./themes/zellis/logo-white.svg": 79462,
	"./themes/zellis/logo.svg": 92375,
	"./trousers.svg": 88332,
	"./unfilled-star.svg": 74608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40968;